import React, { Component } from 'react';
import RenderOnMobile from '../components/responsive/RenderOnMobile';
import RenderOnTablet from '../components/responsive/RenderOnTablet';

export default function withResponsive(WrappedComponent) {

  return function(props) {

    return (
      <React.Fragment>
        <RenderOnMobile>
          <WrappedComponent isMobile={true} isTablet={false} {...props} />
        </RenderOnMobile>

        <RenderOnTablet>
          <WrappedComponent isMobile={false} isTablet={true} {...props} />
        </RenderOnTablet>
      </React.Fragment>
    )
  }
}
